import {createSelector} from 'reselect';

const sortSelector = state => state.sort;

export const selectProjectSort = createSelector(
    sortSelector,
    sort => sort.projects
)

export const selectProjectSortOrder = createSelector(
    sortSelector,
    sort => sort.projects.sortOrder
)

export const selectProjectSortSelection = createSelector(
    sortSelector,
    sort => sort.projects.sortSelection
)

export const selectTaskSort = createSelector(
    sortSelector,
    sort => sort.tasks
)

export const selectTaskSortOrder = createSelector(
    sortSelector,
    sort => sort.tasks.sortOrder
)

export const selectTaskSortSelection = createSelector(
    sortSelector,
    sort => sort.tasks.sortSelection
)